export default [
  {
    path: '/blog',
    name: 'app-blog',
    component: () => import('@/views/apps/blog/BlogList.vue'),
    meta: {
      requiresAuth: true,
      resource: 'ADMIN_B2C',
      action: 'read',
      pageTitle: 'Blog',
      breadcrumb: [{ text: 'Blog', active: true }],
    },
  },
  {
    path: '/blog/novo',
    name: 'app-blog-novo',
    component: () => import('@/views/apps/blog/BlogEditor.vue'),
    meta: {
      requiresAuth: true,
      resource: 'ADMIN_B2C',
      action: 'read',
      pageTitle: 'Novo Post',
      breadcrumb: [
        { text: 'Blog', to: '/blog' },
        { text: 'Novo Post', active: true },
      ],
    },
  },
  {
    path: '/blog/editar/:id',
    name: 'app-blog-editar',
    component: () => import('@/views/apps/blog/BlogEditor.vue'),
    meta: {
      requiresAuth: true,
      resource: 'ADMIN_B2C',
      action: 'read',
      pageTitle: 'Editar Post',
      breadcrumb: [
        { text: 'Blog', to: '/blog' },
        { text: 'Editar Post', active: true },
      ],
    },
  },
  {
    path: '/blog/ai-agent',
    name: 'app-blog-ai-agent',
    component: () => import('@/views/apps/blog/AIAgentSettings.vue'),
    meta: {
      requiresAuth: true,
      resource: 'ADMIN_B2C',
      action: 'read',
      pageTitle: 'Agente de IA',
      breadcrumb: [
        { text: 'Blog', to: '/blog' },
        { text: 'Agente de IA', active: true },
      ],
    },
  },
]
